import { render, staticRenderFns } from "./points.vue?vue&type=template&id=0c879ccd&scoped=true&"
import script from "./points.vue?vue&type=script&lang=js&"
export * from "./points.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c879ccd",
  null
  
)

export default component.exports